import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentHome from './Index.vue';
import AgentAvailability from './Availability.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'agent_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
            // a store manager is an agent: the page and the API scope what they see
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: ':agentId/availability',
          name: 'agent_availability',
          component: AgentAvailability,
          meta: {
            // the schedule screens exist because of the store package, not agent management
            featureFlag: FEATURE_FLAGS.STORE_OPERATIONS,
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
